import { useCallback } from "react";
import { useKeyboardShortcut } from "./useKeyboardShortcut";
/**
 * Registers `H` → pan and `V` → select as global (window-scoped) shortcuts,
 * mirroring the Figma / design-tool convention. Skipped while the user is
 * typing into an input.
 */ export function useCursorModeShortcut(setCursorMode, options = {}) {
    const enabled = options.enabled ?? true;
    const setPan = useCallback(()=>setCursorMode("pan"), [
        setCursorMode
    ]);
    const setSelect = useCallback(()=>setCursorMode("select"), [
        setCursorMode
    ]);
    useKeyboardShortcut({
        combo: "h",
        handler: setPan,
        enabled
    });
    useKeyboardShortcut({
        combo: "v",
        handler: setSelect,
        enabled
    });
}

//# sourceMappingURL=useCursorModeShortcut.js.map